import SharedHeader from '@/components/share/header'
import SharedFooter from '@/components/share/footer'
import SharedTerms from '@/components/share/terms'

export default {
  name: 'terms',
  components: {
    SharedHeader,
    SharedFooter,
    SharedTerms
  }
}



// WEBPACK FOOTER //
// ./src/components/terms/terms.js